export default {
	init() {

		const filterToggle = document.getElementById('toggleFilters')

		if (filterToggle) {
			filterToggle.addEventListener("click", (event) => {
				const filters = document.querySelector(".filter-wrapper")

				filters.classList.toggle("hidden");
			})
		}

	}
}
